
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {MapOptions} from 'vue2-google-maps';
  import {getGooGleMapStyle, GoogleLocationSelected, GoogleMapsMarker} from '@/utils/map';
  import {ClusterOptions} from 'vue2-google-maps/dist/components/cluster';
  import {Ref} from 'vue-property-decorator';
  import {
    authModule,
    challengeModule,
    challengeProblemsModule,
    challengeProblemsState,
    teamsState,
    userModule
  } from '@/utils/store-acessor';
  import {ChallengeModel, ChallengeProblemLocation} from '@/models/challenge.model';
  import GoogleSearch from '@/components/Shared/GoogleSearch.vue';
  import {validators} from '@/utils/validations';
  import {API_URL} from '@/api/axios.config.api';
  import {TeamModel} from '@/models/team.model';

  @Component({
    components: {GoogleSearch}
  })
  export default class ChallengerDetailChallengeMap extends Vue {
    @challengeProblemsModule.Getter('problems')
    problems!: ChallengeProblemLocation[];
    @challengeProblemsModule.Getter('markers') markers!: GoogleMapsMarker[];
    @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
    @userModule.Getter('canAcceptChallenges') canAccept!: boolean;
    @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;
    // @ts-ignore
    @Ref() form: VForm;
    valid = false;
    sending = false;
    infoWindowShowing = false;
    snackbarVisibility: boolean = false;
    snackbarColor: string | null = null;
    snackbarText: string = '';
    rules = validators;

    locale: GoogleLocationSelected | null = null;
    description: string = '';
    file = null;
    loading = false;

    markerSelected: number = 0;
    center = {lat: 45.508, lng: -73.587};
    clusterOptions: ClusterOptions = {
      gridSize: 50,
      maxZoom: 15,
      styles: [
        {
          textColor: 'white',
          url: require('@/assets/icons/cluster.svg'),
          height: 30,
          width: 50
        }
      ]
    };
    mapStyle: MapOptions = {
      styles: getGooGleMapStyle,
      mapTypeControl: false,
      clickableIcons: true,
      streetViewControl: false,
      zoomControl: true,
      zoom: 2,
      maxZoom: 15,
      fullscreenControl: true
    };

    onMarkerClick(index: number) {
      this.markerSelected = index;
      this.infoWindowShowing = !this.infoWindowShowing;
    }

    async mounted() {
      if (this.challenge?.id) {
        await challengeProblemsState.fetchLocalesWithSameProblem(this.challenge.id);
      }
    }

    async onSubmit() {
      this.loading = true;
      this.sending = false;
      if (!this.form.validate()) {
        return;
      }
      if (!this.locale || !this.challenge.id) {
        return;
      }
      try {
        this.sending = true;
        if (this.file) {
          this.sendMultipart(this.challenge.id)
        } else {
          await challengeProblemsState.sendLocaleWithSameProblem({
            challengeId: this.challenge.id,
            payload: {
              longitude: this.locale.longitude,
              location: this.locale.description,
              latitude: this.locale.latitude,
              description: this.description,
            }
          });
        }
        this.snackbarColor = 'green';
        this.snackbarText = 'challenge.messages.location_send';
        this.snackbarVisibility = true;
        this.sending = false;
        this.reset();
      } catch (e) {
        this.sending = false;
        this.snackbarColor = 'red';
        this.snackbarText = 'challenge.messages.location_failed';
        this.snackbarVisibility = true;
      }
    }

    reset() {
      this.locale = null;
      this.description = ' ';
      this.file = null;
      this.loading = false;
    }

    sendMultipart(challengeId: number) {
      const credentials = localStorage.getItem('credentials');
      if (!credentials) {
        return;
      }
      let url = `${API_URL}v1/contestants/challenges/${challengeId}/problem-locations`;
      const formData = new FormData();
      // @ts-ignore
      formData.append('location', this.locale.description);
      // @ts-ignore
      formData.append('longitude', this.locale.longitude);
      // @ts-ignore
      formData.append('latitude', this.locale.latitude);
      // @ts-ignore
      formData.append('description', this.description);
      // @ts-ignore
      formData.append('file', this.file);

      const xhr = new XMLHttpRequest();

      xhr.open('POST', url);
      const {token_type: type, access_token: token} = JSON.parse(credentials);
      xhr.setRequestHeader('Authorization', `${type} ${token}`);
      xhr.onloadstart = (e) => this.start(e);
      xhr.onloadend = (e) => this.finish(e);
      xhr.upload.onprogress = this.updateProgress;
      xhr.send(formData);
    }

    updateProgress(oEvent: ProgressEvent) {
      if (oEvent.lengthComputable) {
        const percentComplete = Math.round((oEvent.loaded * 100) / oEvent.total);
        this.progress(percentComplete);
      }
    }

    private start(event: any): any {
      return event
    }

    private finish(event: any): any {
      return event
    }

    private progress(value: number): number {
      return value;
    }

    locationSelected(event: GoogleLocationSelected) {
      this.locale = event;
    }
  }
